import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import React from "react";
import Loader from "./component/Loader";
import PageBlackListArchived from "./page/blackList/PageBlackListArchived";
import BlackListDetailPage from "./page/blackList/BlackListDetailPage";
import BlacklistExport from "./page/blacklistExports/BlacklistExport";
import TheftMisappropriationEventCard from "./page/theftAndMisappropriation/TheftMisappropriationEventCard";
import TheftMisappropriationDetail from "./page/theftAndMisappropriation/TheftMisappropriationDetail";
import TheftMisappropriationList from "./page/theftAndMisappropriation/TheftMisappropriationList";
import FinesDetail from "./page/fines/FinesDetail";
import Fines from "./page/fines/Fines";

const FinesSecurityMain = () => {

    return (
        <RecoilRoot key='finessecurity'>
            <Routes>
                <Route path="/watchlist/*" element={
                    <PageBlackListArchived/>
                }/>
                <Route path="/watchlist/detail/:id" element={
                    <BlackListDetailPage/>
                }/>
                <Route path="/watchlist/addCustomer" element={
                    <BlackListDetailPage newCustomer={true}/>
                }/>
                <Route path="/watchlistexports/*" element={
                    <BlacklistExport/>
                }/>
                <Route path="/theft-misappropriation" element={
                    <TheftMisappropriationList/>
                }/>
                <Route path="/theft-misappropriation/addEventCard" element={
                    <TheftMisappropriationEventCard/>
                }/>
                <Route path="/theft-misappropriation/detail/:id" element={
                    <TheftMisappropriationDetail/>
                }/>
                <Route path="/fines/*" element={
                    <Fines/>
                }/>
                <Route path="/fines/penalties" element={
                    <Fines/>
                }/>
                <Route path="/fines/detail/:id" element={
                    <FinesDetail/>
                }/>
            </Routes>
            <Loader/>
        </RecoilRoot>
    );
}

export default FinesSecurityMain;